/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![GroupArrowRightIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABvElEQVR4nOWVuUoEQRCGx/MBvFAEQw2MPbJNRaeOAduq9QhdMfQJNvIRzPQJzEUMVERlNRE0MDITxBvxAkFXundc18G9dIwsGIaemfq/qr+aHs/7dwHB2CCwZJD1EUl27To28SCY6ACWW2TNfl5yZ5/HBkDSs68AzQLLrBdX+L7pQpKTWADMyX5g3UGWB3u3awcJxvqQ9S0Uv/2RRc4OlpuI3zcfYkiy5uCoAz+qnig5E/U6rDjlxRFW6DsAsk67DlARWU+BZZlIxPO8mrgt2ox0lkmn07VVQexQkXQbSO/t3Q433yHJeQSw6sUZPskUkjwDyQuizhljGitOTqVSDUQyjqQrSHrhKiS9tmtgnTTG1LkuQHurPioQTQ+wHBQZcDa044BZugvzgGQJWDeGjGktKm6TkOWylDh+QEjOg2CyLQ9g3XDvSI++hSQSifpylWNO2Hnu+8mWwnwrCiyHOYgcDxvT/gVgva2kckSdK+ZASYgbaAUA5qnm0PO9st+T7hcC3G5BloVSScaYplzH7qdTOQBIn4DkdWTEdP6NRazzwLoVtn9VZsijVYnHEfmzqdg2/TWAdRFY16Pi7+DZqPEsScbEAAAAAElFTkSuQmCC)
 */
export const GroupArrowRightIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M14.5 8a3 3 0 1 0-2.7-4.3c-.2.4.06.86.44 1.12a5 5 0 0 1 2.14 3.08c.01.06.06.1.12.1ZM16.62 13.17c-.22.28-.65.37-.92.14-.34-.3-.7-.57-1.09-.82-.52-.33-.7-1.05-.47-1.63.11-.27.2-.57.26-.87.11-.54.55-1 1.1-.92 1.27.16 2.44.65 3.42 1.37.46.34-.31 1.53-.85 1.7a2.99 2.99 0 0 0-1.45 1.03ZM15.19 15.61c.13.16.02.39-.19.39a3 3 0 0 0-1.52 5.59c.2.12.26.41.02.41h-8a.5.5 0 0 1-.5-.5v-2.1c0-.25-.31-.33-.42-.1-.32.67-.67 1.58-.88 2.54a.2.2 0 0 1-.2.16A1.5 1.5 0 0 1 2 20.5a7.5 7.5 0 0 1 13.19-4.89Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M14.97 20a1 1 0 0 1 .03-2h5.59l-2-2-.3-.3a1 1 0 0 1 1.42-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.42-1.4l2.3-2.3h-5.62ZM9.5 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM15.5 22Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
